module.exports = __webpack_public_path__ + "img/guozai_04.2b8bce78.jpg";